import React, { useState } from 'react';
import { Settings as SettingsIcon, Plug, FileType, Users } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { IntegrationsPage } from './IntegrationsPage';
import { DeliveryNoteSettings } from './DeliveryNoteSettings';
import { SettingsGeneral } from './SettingsGeneral';
import { UserManagement } from './UserManagement';
type Tab = 'general' | 'integrations' | 'delivery-note' | 'users';
export function SettingsPage() {
  const [activeTab, setActiveTab] = useState<Tab>('general');
  const tabs = [{
    id: 'general' as Tab,
    label: 'General',
    icon: SettingsIcon
  }, {
    id: 'users' as Tab,
    label: 'Usuarios',
    icon: Users
  }, {
    id: 'integrations' as Tab,
    label: 'Integraciones',
    icon: Plug
  }, {
    id: 'delivery-note' as Tab,
    label: 'Formato Conduce',
    icon: FileType
  }];
  return <div className="p-4 lg:p-8 max-w-6xl mx-auto" data-id="element-2575">
      <div className="mb-8" data-id="element-2576">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-2577">
          Configuración
        </h1>
        <p className="text-gray-500 dark:text-gray-400 mt-1" data-id="element-2578">
          Administra la configuración general del sistema
        </p>
      </div>

      {/* Tabs */}
      <div className="mb-6" data-id="element-2579">
        <div className="border-b border-gray-200 dark:border-gray-800" data-id="element-2580">
       <nav className="flex gap-2 overflow-x-auto scrollbar-hide -mb-px" data-id="element-2581">
  {tabs.map(tab => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-2 px-4 py-3 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${isActive ? 'border-black text-black dark:border-white dark:text-white' : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-700'}`} data-id="element-2582">
        <Icon size={18} data-id="element-2583" />
        {tab.label}
      </button>;
          })}
        </nav>
        </div>
      </div>

      {/* Tab Content */}
      <div data-id="element-2584">
        {activeTab === 'general' && <SettingsGeneral data-id="element-2585" />}
        {activeTab === 'users' && <UserManagement data-id="element-2586" />}
        {activeTab === 'integrations' && <IntegrationsPage data-id="element-2587" />}
        {activeTab === 'delivery-note' && <DeliveryNoteSettings data-id="element-2588" />}
      </div>
    </div>;
}